import { EmptyResult } from '@package/services/src/Result'

import { CheckoutPaymentFormData } from '../types'

import { MoneyOrderPaymentService } from './services'

export default class MoneyOrderPaymentInteractor {
  public constructor(
    private moneyOrderPaymentService: MoneyOrderPaymentService
  ) { }

  public async checkout(
    request: CheckoutPaymentFormData
  ): Promise<EmptyResult> {
    return this.moneyOrderPaymentService.checkout()
  }
}
